import type { ClientQuestion, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export interface TrueFalseProps {
  question: Extract<ClientQuestion, { kind: 'truefalse' }>;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  locale: LocaleCode;
  trueLabel?: string;
  falseLabel?: string;
}

/**
 * kind: 'truefalse' — emits a BOOLEAN (true / false), the exact shape the server
 * grader compares against the authored boolean `correct` (Plan 5: zod
 * z.boolean()). Labels are chrome (cs-CZ defaults, overridable by the consuming
 * app). The radio `value` strings are DOM-only and never leave the widget.
 */
export function TrueFalse({
  question,
  value,
  onChange,
  locale,
  trueLabel = 'Ano',
  falseLabel = 'Ne',
}: TrueFalseProps) {
  const options: { bool: boolean; label: string }[] = [
    { bool: true, label: trueLabel },
    { bool: false, label: falseLabel },
  ];
  return (
    <fieldset data-quiz-kind="truefalse">
      <legend>{resolveLocalized(question.prompt, locale)}</legend>
      {options.map((opt) => (
        <label key={String(opt.bool)}>
          <input
            type="radio"
            name={question.id}
            value={String(opt.bool)}
            checked={value === opt.bool}
            onChange={() => onChange(opt.bool)}
          />
          {opt.label}
        </label>
      ))}
    </fieldset>
  );
}
